// extracted by css-extract-rspack-plugin
export default {"cls1":"FocusedNav-cls1_Vd1","cls2":"FocusedNav-cls2_sRR FocusedNav-cls1_Vd1"};